import React from 'react';
import { Box, Typography, Container, Paper } from '@mui/material';

export const Skills = () => {
  return (
    <Box id="skills" sx={{ py: 8, bgcolor: 'background.paper' }}>
      <Container>
        <Typography variant="h2" gutterBottom>
          Skills
        </Typography>
        <Paper
          sx={{
            p: 3,
            borderRadius: 4,
            backgroundColor: '#1976d2',
            color: '#fff',
            boxShadow: 3,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 4,
            }}
          >
            {/* First Column */}
            <Box component="ul" sx={{ flex: 1, pl: 3, m: 0 }}>
              <li>Technical Analysis</li>
              <li>Python, R, SQL Software Proficiency</li>
              <li>Analytical and Critical Thinking</li>
              <li>Network configuration</li>
              <li>Amazon AWS</li>
              
            </Box>
            {/* Second Column */}
            <Box component="ul" sx={{ flex: 1, pl: 3, m: 0 }}>
              <li>Elastic Load Balancing</li>
              <li>Continuous Integration and Deployment</li>
              <li>SQL Databases</li>
              <li>Power BI Tools, Tableau dashboards</li>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default Skills;